import { render, staticRenderFns } from "./OrticInput.vue?vue&type=template&id=42ba8408&"
import script from "./OrticInput.vue?vue&type=script&lang=js&"
export * from "./OrticInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports